import { render, staticRenderFns } from "./MiniDepStatTableDepCountries.component.vue?vue&type=template&id=4cdf3ee2&scoped=true&"
import script from "./MiniDepStatTableDepCountries.component.vue?vue&type=script&lang=js&"
export * from "./MiniDepStatTableDepCountries.component.vue?vue&type=script&lang=js&"
import style0 from "./MiniDepStatTableDepCountries.component.vue?vue&type=style&index=0&id=4cdf3ee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdf3ee2",
  null
  
)

export default component.exports